import {ContactEventList, ContactEventRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip, PersonAvatar, euros} from "../../../../components/kit";
import {Box, Stack, Typography} from "@mui/material";
import {CONTACT_EVENT_TYPE} from "../labels";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";

export const ContactEventListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<ContactEventList> = {
        title: "Interacciones",
        onClick: "/app/admin/marketing/contact-event",
        headers: [
            {title: "Fecha"},
            {title: "Contacto"},
            {title: "Tipo"},
            {title: "Descripción"},
        ],
        decorator: (bean: ContactEventList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    {bean.issueDate ? String(bean.issueDate).replace("T", " ").substring(0, 16) : "-"}
                </TableCell>
                <TableCell>{bean.contact?.surnamesAndName ?? "-"}</TableCell>
                <TableCell>{bean.type ? <SoftChip tone="info" label={CONTACT_EVENT_TYPE[bean.type] ?? bean.type}/> : "—"}</TableCell>
                <TableCell>
                    <Typography variant="body2" noWrap title={bean.description}>{bean.description ?? "—"}</Typography>
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(ContactEventRestControllerApiFactory);
            return ctrl.pageContactEvent(currentPage, size, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
